// Abra - Product
// Isolated from abra.js to improve Recharge 2.0 widget - updated 3.21.2026 NNC

(() => {
  if (!window.location.pathname.includes('/products')) return;
  
  const process = () => {
    let widgetFoundAndUpdated = false;

    // OPTIMIZATION: Try to replace '*' with the actual Recharge custom element tag 
    // e.g., document.querySelectorAll('recharge-widget') or similar. 
    // If you don't know it, '*' works safely now because we debounced the calls below.
    const elements = document.querySelectorAll('*'); 

    for (let el of elements) {
      if (!el.shadowRoot) continue;
      
      const subscribePrice = el.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices');
      const buyOncePrice = el.shadowRoot.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
      
      let localUpdate = false;

      if (subscribePrice && !subscribePrice.classList.contains('subscribe-opt')) {
        subscribePrice.classList.add('subscribe-opt');
        localUpdate = true;
      }
      
      if (buyOncePrice && !buyOncePrice.classList.contains('buy-once-opt')) {
        buyOncePrice.classList.add('buy-once-opt');
        localUpdate = true;
      }
      
      if (localUpdate) {
        widgetFoundAndUpdated = true;
      }
    }

    // Only render Abra once after all widgets have been updated
    if (widgetFoundAndUpdated && window.Abra) {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      window.Abra.render();
      return true;
    }
    
    return false;
  };

  // Polling fallback
  let attempts = 0;
  const interval = setInterval(() => {
    if (process() || ++attempts >= 20) clearInterval(interval);
  }, 200);
  
  // DEBOUNCED MutationObserver to prevent browser freezing
  let timeoutId;
  const observer = new MutationObserver(() => {
    clearTimeout(timeoutId); // Cancel the previous scan if the DOM is still changing
    timeoutId = setTimeout(() => {
      process();
    }, 150);
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
})();

console.log("SCRIPT_LOAD: abra-product.js");